import { render, staticRenderFns } from "./GetCharacterName.vue?vue&type=template&id=50c309b0&scoped=true&"
import script from "./GetCharacterName.vue?vue&type=script&lang=js&"
export * from "./GetCharacterName.vue?vue&type=script&lang=js&"
import style0 from "./GetCharacterName.vue?vue&type=style&index=0&id=50c309b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c309b0",
  null
  
)

export default component.exports